import api from '@/services/api'

export const getSubordinates = async userID => {
    try {
        return api.get(`users/${userID}/profile/subordinates`)
    } catch (e) {
        console.log(e)
    }
}

export const updateHasPermissionToAccessManagerProfile = async (
    userID,
    status
) => {
    try {
        const response = status ? 1 : 0
        return api.put(
            `users/${userID}/update-has-permission-to-access-manager-profile/${response}`
        )
    } catch (e) {
        console.log(e)
    }
}
